export const NAV_ITEMS = [
  ['hero',      'Home'],
  ['projects',  'Projects'],
  ['about',     'About'],
  ['techstack', 'Stack'],
  ['contact',   'Contact'],
];
